import React from 'react';
import { useT } from '@repo/common';

// 다른 마이페이지 목록의 Empty* 컴포넌트와 같은 레이아웃
const EmptyCoupon = ({ currentFilter }) => {
  const t = useT();
  const message =
    currentFilter === 'Active'
      ? t('No coupons yet', '보유한 쿠폰이 없습니다')
      : t('No used or expired coupons', '사용했거나 만료된 쿠폰이 없습니다');

  return (
    <div className='flex flex-col justify-center items-center tabletH:p-10 h-[180px] tabletH:h-[380px]'>
      <div className='tabletH:pb-6 w-full max-w-[570px] flex items-center justify-center text-text-placeholder typo-b14'>
        {message}
      </div>
    </div>
  );
};

export default EmptyCoupon;
